export function formatCurrency(value) {
    if (isNaN(value)) return value;
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function unformatCurrency(value) {
    return value.replace(/\D/g, '') / 100;
}

export function formatQuantidade(value) {
    if (value === null || value === undefined || isNaN(value)) return '';
    
    const num = parseFloat(value);
    const isInteger = Number.isInteger(num) || num % 1 === 0;
    
    if (isInteger) {
        return num.toString();
    }
    
    // Formata com 2 casas decimais e substitui ponto por vírgula
    return num.toFixed(2).replace('.', ',');
}